module.exports = __webpack_public_path__ + "img/information_set.d24f3741.png";